import React from 'react';
import { Link } from 'react-router-dom';
interface Article {
  title: string;
  excerpt: string;
  imageUrl: string;
  author: string;
  date: string;
  category?: string;
}
interface RelatedArticlesProps {
  articles: Article[];
}
export const RelatedArticles = ({
  articles
}: RelatedArticlesProps) => {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-262">
      {articles.map((article, index) => {
      // Find the article index in the original newsData array
      const articleId = index;
      return <Link to={`/article/${articleId}`} key={index} className="group" data-id="element-263">
            <article className="bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow h-full" data-id="element-264">
              <div className="relative h-48" data-id="element-265">
                <img src={article.imageUrl} alt={article.title} className="w-full h-full object-cover" data-id="element-266" />
              </div>
              <div className="p-4" data-id="element-267">
                {article.category && <span className="inline-block bg-blue-100 text-blue-800 px-2 py-1 text-xs font-medium rounded mb-2" data-id="element-268">
                    {article.category.toUpperCase()}
                  </span>}
                <h3 className="font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-269">
                  {article.title}
                </h3>
                <div className="flex items-center text-gray-500 text-xs mt-2" data-id="element-270">
                  <span className="mr-3" data-id="element-271">{article.author}</span>
                  <span data-id="element-272">{article.date}</span>
                </div>
              </div>
            </article>
          </Link>;
    })}
    </div>;
};